import { render, staticRenderFns } from "./second_articleForm.vue?vue&type=template&id=455f9656&scoped=true&"
import script from "./second_articleForm.vue?vue&type=script&lang=js&"
export * from "./second_articleForm.vue?vue&type=script&lang=js&"
import style0 from "./second_articleForm.vue?vue&type=style&index=0&id=455f9656&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f9656",
  null
  
)

export default component.exports